import { getServerTranslator } from './serverI18n';

const URL_CHART_TYPE_KEY = {
  'net-worth': 'chartType.netWorth',
  'annual-income': 'chartType.annualIncome',
  'retirement-fund': 'chartType.retirementFund',
};

const getChartTypeLabel = (slug, locale = 'en-US') => {
  const key = URL_CHART_TYPE_KEY[slug];
  if (!key) return '';
  const { t } = getServerTranslator(locale);
  return t(key);
};

const localStorageMap = {
  'head-charts': 'lm_head_data',
  'height-charts': 'lm_heigh_data',
  'weight-charts': 'lm_weight_data',
  'bmi-charts': 'lm_bmi_data',
};

const formulateGenderAndChartType = function (hashArray, locale = 'en-US') {
  return getChartTypeLabel(hashArray[1], locale);
};

const capitalize = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const parseUrlForGenderWithString = (parts, locale = 'en-US') => {
  const gender = parts?.[2] || parts?.[1];
  const { t } = getServerTranslator(locale);
  switch (gender) {
    case 'men':
      return t('form.men');
    case 'women':
      return t('form.women');
    case 'household':
      return t('household.household');
    default:
      return '';
  }
};

const parseGenderForAlternativeLink = function (hashArray, ageInMonths = false) {
  const url_fragment = hashArray[2];
  let gender = 'men'; // default fallback

  switch (url_fragment) {
    case 'women':
      gender = 'men';
      break;
    case 'men':
      gender = 'women';
      break;
    case 'household':
      gender = 'household';
      break;
  }

  return gender;
};

const enablePrimaryLink = function (age_key, age_value) {
  return /week|baby|year-old|years-old|old-baby|[1-2][0-9]-month-old/.test(age_value) || /half/.test(age_key);
};

export {
  getChartTypeLabel,
  formulateGenderAndChartType,
  parseUrlForGenderWithString,
  enablePrimaryLink,
  localStorageMap,
  parseGenderForAlternativeLink,
  capitalize,
};
